import { restoreAndMirrorLocalStorage } from '@examdojo/browser/preferences';

// This file must import nothing but the mirror, and must reach the app through a dynamic
// import. A module's whole static import graph is evaluated before its own first statement,
// and the app's graph holds modules that read `localStorage` while being evaluated — a
// persisted store rehydrating, a config constant resolved at module scope. A top-level
// `await` in a statically imported module would not help either: ESM keeps evaluating
// siblings while an async module is pending, so the ordering would silently depend on the
// bundler. Adding a second static import here reintroduces the bug with nothing to fail.
restoreAndMirrorLocalStorage()
  // A restore that fails must degrade to "settings look default", never to "the app does
  // not boot" — an invariant of this seam rather than of the mirror, so it is asserted here
  // even though the mirror handles its own failures.
  .catch(() => undefined)
  .then(() => import('./bootstrap'))
  // The dynamic import moved `bootstrapApplication`'s own catch inside the chunk, leaving a
  // chunk that never loads with nothing to report it but a blank page.
  .catch((error: unknown) => console.error('Failed to load the application bootstrap', error));
